import dayjs, { Dayjs } from 'dayjs';

export type DateRange = {
  from: Dayjs | null;
  to: Dayjs | null;
};

const DATE_FORMAT = 'YYYY-MM-DD';

const ACTIVE_VALUES: Record<string, boolean | undefined> = {
  true: true,
  false: false,
};

export const replaceParam = (params: URLSearchParams, key: string, value: string | null) => {
  params.delete(key);
  value && params.set(key, value);
};

export const replaceParams = (params: URLSearchParams, key: string, values: string[]) => {
  params.delete(key);
  values.forEach((value) => params.append(key, value));
};

export const readDateRange = (params: URLSearchParams): DateRange => ({
  from: params.get('createdFrom') ? dayjs(params.get('createdFrom')) : null,
  to: params.get('createdTo') ? dayjs(params.get('createdTo')) : null,
});

export const replaceDateRange = (params: URLSearchParams, range: DateRange) => {
  replaceParam(params, 'createdFrom', range.from?.format(DATE_FORMAT) ?? null);
  replaceParam(params, 'createdTo', range.to?.format(DATE_FORMAT) ?? null);
};

export const toArrayFilter = (values: string[]) => (values.length ? { shouldInclude: true, values } : undefined);

export const toDateFilter = ({ from, to }: DateRange) =>
  from && to
    ? {
        from: from.format(DATE_FORMAT),
        to: to.format(DATE_FORMAT),
      }
    : undefined;

export const toActiveFilter = (value: string) => ACTIVE_VALUES[value];
